import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from './ui/avatar';

const BACKEND = process.env.REACT_APP_BACKEND_URL;

function resolveUrl(url) {
  if (!url) return null;
  if (url.startsWith('http')) return url;
  if (url.startsWith('/api/')) return `${BACKEND}${url}`;
  return url;
}

export default function UserAvatar({ user, size = 'md', className = '' }) {
  const sizes = { xs: 'h-8 w-8 text-xs', sm: 'h-10 w-10 text-sm', md: 'h-14 w-14 text-lg', lg: 'h-24 w-24 text-2xl', xl: 'h-32 w-32 text-3xl' };
  const initials = (user?.name || user?.username || '?').split(/\s+/).map((s) => s[0]).slice(0, 2).join('').toUpperCase();
  return (
    <Avatar className={`${sizes[size]} ring-2 ring-aura-cyan/40 shadow-neon-cyan ${className}`}>
      {resolveUrl(user?.avatar_url) && <AvatarImage src={resolveUrl(user?.avatar_url)} alt={user?.username} />}
      <AvatarFallback className="bg-aura-surface2 text-white font-display font-bold">{initials}</AvatarFallback>
    </Avatar>
  );
}
